/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Total_CustomersInputs */

const vi_dashboard_total_customers = /** @type {(inputs: Dashboard_Total_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng khách hàng`)
};

/**

* @param {Dashboard_Total_CustomersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_total_customers = /** @type {((inputs?: Dashboard_Total_CustomersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Total_CustomersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_total_customers(inputs)
});